<!-- 手写的一个视频组件 -->
<template>
    <div class='video-content-wrapper'>
        <div class='video-content-iconlist' 
            @touchstart='bind_toogle_play'
            :class="{ icon_active: !icon_show }">
            <i class="icon iconfont icon-b"
                v-show="icon_play"></i>
            <i class="icon iconfont icon-bofang"
                v-show="!icon_play"></i>
        </div>
        <video 
            :height='height'
            :width='width'
            :src="src"
            ref='video'
            :poster="poster"
            @click='_bind_check_dblclick(bind_toogle_play)'>
        </video>
        <div class='video-process-bar-wrapper' 
            :class="{ process_active: play }">
            <div class='video-process-bar-mask'>
            </div>
            <div class='video-process-bar'>
                <div class='video-process-curTime'>
                    {{curTime}}
                </div>
                <div 
                    class='video-process-scrollbar-wrapper'
                    ref='barwrapper'
                    @click='bind_process_jump'>
                    <div class='video-process-scrollbar'>
                    </div>
                    <div 
                        class='video-process-curscrollbar' 
                        ref='curbar'>
                        <span 
                            class='video-process-dotscrollbar' 
                            @touchstart='bind_process_start'
                            @touchmove='bind_process_move'
                            @touchend='bind_process_end'></span>
                    </div>
                    <div class='video-process-loadscrollbar'
                        ref='loadbar'>
                    </div>
                </div>
                <div class='video-process-totalTime'>
                    {{totalTime}}
                </div>
            </div>
        </div>
        <div class='video-process-bar-mini' 
            :class="{ process_active: !play }">
            <div 
                class='video-process-mini-curscrollbar' 
                ref='curbar_mini'>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        width: {
            type: String,
            default() {
                return '100%';
            }
        },
        poster: {
            type: String,
            default() {
                return '';
            }
        },
        height: {
            type: String,
            default() {
                return '100%';
            }
        },
        autoPlay: {
            type: Boolean,
            default() {
                return false;
            }
        },
        loop: {
            type: Boolean,
            default() {
                return false;
            }
        },
        src: {
            type: String,
            default() {
                return '';
            }
        }
    },
    computed: {
        
    },
    data () {
		return {
            // 显示icon
            icon_show: true,
            icon_play: false,
            // 播放状态
            play: false,
            // 记录touchtime，模拟移动端双击
            touchtime: 0,
            // 目前时间
            curTime: '',
            // 总时间
            totalTime: '',
            // 是否结束播放
            ended: false
		}
	},
    methods: {
        _bind_check_dblclick: function(cb) {
            // 双击模拟
            if (this.touchtime != 0 && (new Date().getTime() - this.touchtime < 500)) {
                cb && cb();
            } else {
                this.touchtime = new Date().getTime();
                this.play = !this.play;
            }
        },
        // 切换播放状态
        bind_toogle_play: function() {
            this.icon_show = true;
            if (!this.video.paused) {
                this.video.pause();
                this.play = false;
                this.icon_play = false;
            } else {
                this.video.play();
                this.play = true;
                this.icon_play = true;
                setTimeout(() => {
                    this.icon_show = false;
                }, 2000)
            }
        },
        // 点击进度条跳转
        bind_process_jump: function(e) {
            // 如果视频暂停的时候点击跳转，clear掉原来的计时器
            if (!this.video.paused) {
                clearInterval(this.start_timer);
            }
            // 计算跳转的偏移百分比
            let move = e.clientX - this.barwrapper_offsetLeft;
            let proportion = move/this.barwrapper_width;
            if (move > this.barwrapper_width) {
                // 如果改变的幅度过大，从99%播放
                proportion = 0.99;
            } else if (move < 0) {
                return;
            }
            this.curbar_width = this.barwrapper_offsetLeft * proportion;
            this.curbar.style.width = `${proportion*100}%`;
            // 改变当前的播放时间
            this._bind_process_jump(proportion)
        },
        // 改变当前播放时间和状态
        _bind_process_jump: function(ppt) {
            console.log(ppt);
            this.ppt = ppt*100;
            this.video.currentTime = this.video.duration*ppt;
            this.video.play();
            // 图标先变play
            this.icon_play = true;
            this.move_timer = setTimeout(() => {
                this.play = true;
                this.icon_show = false;
            }, 3000)
        },
        // 根据秒数计算分秒显示
        _bind_cacal_time: function(sec) {
            let hour = `0${parseInt(sec/3600)}`.slice(-2);
            let min = `0${parseInt(sec/60)}`.slice(-2);
            let second = `0${parseInt(sec%60)}`.slice(-2);
            if (hour == '00') {
                return `${min}:${second}`;
            } else {
                return `${hour}:${min}:${second}`;
            }
        },
        // 拖动进度条逻辑
        bind_process_start: function(e) {
            // 初始化位置
            this.process_start = e.touches[0].clientX;
        },
        bind_process_move: function(e) {
            clearTimeout(this.move_timer);
            // 获得移动距离
            this.move = e.touches[0].clientX - this.process_start;
            // 算出当前偏移量和总长的比例
            const cur_proportion = (this.curbar_width + this.move) / this.barwrapper_width;
            // 如果比例超出界限，直接return
            if (cur_proportion > 1 || cur_proportion < 0) {
                return;
            } else {
                this.curbar.style.width = `${cur_proportion*100}%`;
            }
        },
        bind_process_end: function() {
            // 更新每次偏移之后的初始位置
            let cur_move = this.curbar_width + this.move;
            let proportion = cur_move/this.barwrapper_width;
            // 计算边界情况
            if (cur_move > this.barwrapper_width) {
                 // 如果改变的幅度过大，从99%播放
                proportion = 0.99;
            } else if (cur_move < 0) {
                proportion = 0;
            }
            this.curbar_width = this.barwrapper_width * proportion;;
            this.curbar.style.width = `${proportion*100}%`;
            this.curbar_mini.style.width = `${proportion*100}%`;
            // 初始化
            this._bind_process_jump(proportion)
            this.move = 0;
            this.process_start = 0;
        },
        // 播放的逻辑
        bind_process_play: function(proportion) {
            let per_curbar_width = this.barwrapper_width/100;
            // 如果播放结束，重新播放
            if (this.ended) {
                this.ppt = 0;
                this.curbar_width = 0;
                this.ended = false;
            }  else if (this.curbar_width >= this.barwrapper_width) {
                this.video.pause();
            }
            this.start_timer = setInterval(() => {
                this.ppt = this.ppt + proportion;
                this.curbar_width += per_curbar_width;
                console.log(`${this.ppt}%`);
                this.curbar.style.width = `${this.ppt}%`;
                this.curbar_mini.style.width = `${this.ppt}%`;
                this.curTime = this._bind_cacal_time(this.video.currentTime);
            }, 1000)   
        },
        // 暂停的逻辑
        bind_process_pause: function() {
            if (this.video.ended) {
                this.curbar_width = this.barwrapper_width;
                this.curbar_mini_width = 0;
                this.curTime = this._bind_cacal_time(this.video.duration);
                this.ppt = 100;
                // 手动设置状态 重新播放的判断
                this.ended = true;
            }
            clearInterval(this.start_timer);
        },
        bind_check_loading: function() {
            this.load_timer = setInterval(() => {
                if (this.ppt_loading >= 1) {
                    clearInterval(this.load_timer);
                }
                let currentBuffered = this.video.buffered.end(0);
                console.log('currentBuffered', currentBuffered);
                if (currentBuffered) {
                    let cur_proportion = currentBuffered/this.video.duration;
                    this.ppt_loading = this.ppt_loading + cur_proportion;
                    this.loadbar.style.width = `${this.ppt_loading*100}%`;
                    console.log('ppt_loading', this.ppt_loading);
                }
            }, 1000)            
        }
    },
    mounted() {
        // 获取video元素
        this.video = this.$refs.video;
        // 获取进度条元素
        this.barwrapper = this.$refs.barwrapper;
        // 获取目前进度条元素
        this.curbar = this.$refs.curbar;
        // 获取小进度条的元素
        this.curbar_mini = this.$refs.curbar_mini;
        // 获取缓冲进度的元素
        this.loadbar = this.$refs.loadbar;
        // 目前进度条长度
        this.curbar_width = 0;
        // 目前小进度条长度
        this.curbar_mini_width = 0;
        // 目前缓存条比例
        this.ppt_loading = 0;
        // 目前进度比例
        this.ppt = 0;
        let that = this;
        // 滚动条的长度
        this.barwrapper_width = this.barwrapper.getBoundingClientRect().width;
        // 滚动条的偏移量
        this.barwrapper_offsetLeft = this.barwrapper.getBoundingClientRect().left;
        // 目前进度时间
        this.curTime = this._bind_cacal_time(0);
        // 监听媒体的事件
        this.video.onplaying = function() {
            console.log('playing')
            this.ppt = that.video.currentTime/that.video.duration * 100;
            that.curbar_mini.style.width = `${this.ppt}%`;
            that.bind_process_play(100/that.video.duration);
        }
        this.video.onpause = function() {
            console.log('pause')
            that.bind_process_pause();
        }
        this.video.oncanplay = function() {
            console.log('can play')
            that.$emit('callback', that._bind_cacal_time(that.video.duration));
            // 总进度时间
            that.totalTime = that._bind_cacal_time(that.video.duration);
        }
        this.video.onwaiting = function() {
            console.log("can't play");
            that.start_timer && clearInterval(that.start_timer);
        }
        // 检查缓存进度
        // this.bind_check_loading();
    }
}
</script>
<style scoped>
    .video-content-wrapper {
        width: 100%;    
        margin: .213333rem 0;
        position: relative;
        /* height: 2.666667rem; */
    }
    .video-content-wrapper .video-content-iconlist {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1000;
        transition: 0.5s;
    }
    .video-content-wrapper .video-content-iconlist.icon_active {
        opacity: 0;
    }
    .video-content-wrapper .video-content-iconlist i {
        font-size: .533333rem;
        font-weight: bold;
        z-index: 1;
    }
    .video-content-wrapper video {
        width: 100%;
        height: 100%;
        object-fit:fill;
    }
    .video-process-bar-mini {
        position: absolute;
        background: #fff;
        opacity: 0.5;
        width: 100%;
        height: .026667rem;
        bottom: 0;
        left: 0;
        transition: 0.5s;
    }
    .video-process-mini-curscrollbar {
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: .026667rem;
        background: #FE1B1B;
    }
    .video-process-bar-wrapper {
        position: absolute;
        width: 100%;
        height: .4rem;
        bottom: 0;
        left: 0;
        transition: 0.5s;
    }
    .video-process-bar-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.5;
        top: 0;
        left: 0;
        color: #fff;
    }
    .video-process-bar {
        font-size: .173333rem;
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        top: 0;
        left: 0;
        display: flex;
        color: #fff;
        justify-content: center;
        align-items: center;
        opacity: 1;
        z-index: 999
    }
    .video-process-scrollbar-wrapper {
        width: 2.6rem;
        height: .026667rem;
        border-radius: .033333rem;
        margin: 0 .186667rem;
        position: relative;
    }
    .video-process-scrollbar {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: .026667rem;
        background: #fff;
        opacity: 0.4;
        z-index: 0;
    }
    .video-process-curscrollbar {
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: .026667rem;
        background: #FE1B1B;
        opacity: 1;
        z-index: 2;
    }
    .video-process-curscrollbar .video-process-dotscrollbar {
        position: absolute;
        right: -.08rem;
        top: -.066667rem;
        width: .16rem;
        height: .16rem;
        border-radius: 50%;
        background: #fff;
        z-index: 2;
    }
    .video-process-loadscrollbar {
        transition: 1s;
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: .026667rem;
        background: #fff;
        opacity: 0.6;
        z-index: 1;
    }
    .process_active {
        transform: scaleY(0);
    }
</style>


// WEBPACK FOOTER //
// src/components/StreamVideoPlayer.vue